export default function CampaignSection() {
  const campaigns = [
    {
      name: '三井住友カード（NL）',
      benefit: '最大25,600円相当プレゼント',
      condition: '新規入会＋利用で',
      deadline: '終了日未定',
      highlight: true
    },
    {
      name: '大手ECモール系カード',
      benefit: '5,000ポイント進呈',
      condition: '新規入会特典',
      deadline: '終了日未定',
      highlight: false
    },
    {
      name: 'リクルートカード',
      benefit: '最大6,000円分ポイント',
      condition: '新規入会＋利用で',
      deadline: '終了日未定',
      highlight: false
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 rounded-full font-bold mb-4">
            🔥 今月のおすすめキャンペーン
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            即日発行カードの入会特典
          </h2>
          <p className="text-gray-700">
            現在、以下のカードで入会特典キャンペーン実施中です
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {campaigns.map((campaign, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl shadow-lg p-6 ${
                campaign.highlight ? 'ring-4 ring-amber-400' : ''
              } hover:shadow-xl transition-all duration-300`}
            >
              {campaign.highlight && (
                <div className="bg-gradient-to-r from-amber-400 to-orange-400 text-white text-sm font-bold px-3 py-1 rounded-full inline-block mb-4">
                  おすすめ
                </div>
              )}
              <h3 className="font-bold text-gray-900 text-lg mb-3">{campaign.name}</h3>
              <div className="mb-4">
                <div className="text-3xl font-bold text-teal-600 mb-2">
                  {campaign.benefit}
                </div>
                <div className="text-sm text-gray-600">{campaign.condition}</div>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
                <i className="ri-time-line"></i>
                <span>{campaign.deadline}</span>
              </div>
              <a
                href="#apply"
                className="block w-full bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-3 rounded-lg font-bold text-center hover:from-teal-600 hover:to-teal-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                詳細を見る
              </a>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-amber-500 text-3xl flex-shrink-0"></i>
            <div>
              <h4 className="font-bold text-gray-900 mb-2">キャンペーン適用の注意点</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i>
                  <span>特典を受け取るには、各カード会社が定める条件を満たす必要があります</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i>
                  <span>キャンペーン内容は予告なく変更・終了する場合があります</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-0.5"></i>
                  <span>最新のキャンペーン情報は各公式サイトでご確認ください</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
